import React from 'react'
import Footer from '../../components/Footer'
import Header from '../../components/Header'
import "../../assets/css/Chat.css"
import { profileLogo } from '../../Constant'

function AllJobs() {
  return (
    <>
    <Header />
        <section className="jobs">
    <div className="container">
        <div className="row">
            <div className="col-md-12">
                <h4 className="blue">All Jobs</h4>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore
                    et dolore magna aliqua. .
                </p>
            </div>
        </div>
    </div>
    <div className="container">
        <div className="row">
            <div className="col-md-9 careGiverAllJobs">
                <div className="row py-5">
                    <div className="col-md-10">
                        <div className="records"><b>Showing <span className="currentCustomerJobs"></span> of <span className="totalCustomerJobs"></span> Jobs Results:</b> <br /><span className="based-pref" style={{display: "none"}}>Based your preferences</span></div>
                    </div>
                    <div className="col-md-2 ">
                        <select className="form-select form-select-lg mb-3 select1"
                                aria-label=".form-select-lg example">
                            <option selected="">Newest</option>
                            <option value="1">Oldest</option>
                            <option value="2">A-Z</option>
                            <option value="3">Z-A</option>
                        </select>
                    </div>
                </div>
                {/* <?php include('inc/table.php')?> */}
            </div>
            <div className="col-md-3 box-shadow-only-hover hover-top profilebox col-xs-12">
                <div className="card profile ">
                    <div className="card-body box-blue">
                        <div className="d-flex flex-column align-items-center ">
                            <div className="img-back"></div>
                            <img src={profileLogo} alt="Admin" className="text-center " width="150" />
                            <div className="mt-3">
                                <h4 className="text-center">Lorem Ipsum</h4>
                                <p className="text-secondary mb-1 orange text-center">Bubbles Studios</p>
                                <ul className="tr-list job-meta list-unstyled job-social tr-list ul-color">
                                    <li> Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
                                        tempor incididunt ut labore
                                    </li>
                                </ul>
                                <div className="j-list">
                                        <ul className="tr-list job-meta list-unstyled job-social tr-list ul-color">
                                        <li><i className="fa fa-star " aria-hidden="true"></i> Tempor incididunt ut
                                            labore
                                        </li>
                                        <li><i className="fa fa-star " aria-hidden="true"></i> Lorem ipsum dolor
                                        </li>
                                        <li><i className="fa fa-star " aria-hidden="true"></i> Sit amet consectetur
                                        </li>
                                        <li><i className="fa fa-star " aria-hidden="true"></i> Labore adipsicans elit do uasde
                                        </li>
                                    </ul>
                                </div>
                                <button className="btn btn-jobs">Join As a Care Giver</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </section>
    <Footer />
    </>
  )
}

export default AllJobs